import {
  lang as defaultLocale,
  langList as supportLocale,
  SYSTEM_SYMBOL,
} from './config/appMeta';

export const AppPath = `/${SYSTEM_SYMBOL}`;

const localeRegStr = '(en)|([a-z]{2,3}-[A-Z0-9]{2,3})';
const localeReg = new RegExp(`^/(${localeRegStr})/`);

const cacheMap = new Map();

const data: Record<string, object> = {};

export const getI18nLangPack = async (project: string, locale: string) => {
  let env = '';
  switch (process.env.NEXT_PUBLIC_BYBIT_ENV) {
    case 'testnet':
      env = 'testnet-';
      break;
    case 'prd':
      env = '';
      break;
    default:
      env = 'test-';
  }
  if (data[locale]) {
    return data[locale];
  }
  const langUrl = `https://fh-static.bycsi.com/i18n-upload/low-cache/project/release/${project}/${env}${locale}.json`;
  if (!cacheMap.has(langUrl)) {
    const myPromise = fetch(langUrl, {
      method: 'GET',
    }).then((res) => res.json());
    cacheMap.set(langUrl, myPromise);
  }
  data[locale] = cacheMap.get(langUrl);
  return cacheMap.get(langUrl);
};

/**
 * 将地址一般化为可以用于导航的地址，
 * 例如：/collections 转换为：/当前语言/AppPath/collections
 * /AppPath/collections 转换为：/当前语言/AppPath/collections
 * /某语言/AppPath/
 *
 * @param to 目标地址
 */
export function normalizeLink(to: string, locale: string = ''): string {
  let fixedLocale = locale;

  if (!locale || !isSupportedLocale(locale)) {
    fixedLocale = getCurrentLocale() || getDefaultLocale();
  }

  if (to === '' || to === '/') {
    return `/${fixedLocale}${AppPath}`;
  }

  // todo locale to support locale types
  if (to.startsWith(AppPath) && to !== '/') {
    return `/${fixedLocale}${to}`;
  }
  const toLocale = getLocaleFromPathname(to);

  if (toLocale) {
    if (!locale && isSupportedLocale(toLocale)) {
      return to;
    }
    return to.replace(localeReg, `/${fixedLocale}/`);
  } else {
    return `/${fixedLocale}${AppPath}${to}`;
  }
}

export function getLocaleFromPathname(pathname: string): string {
  return pathname.match(localeReg)?.[1] ?? '';
}

export function getCurrentLocale() {
  const locale = getLocaleFromPathname(window.location.pathname);
  return isSupportedLocale(locale) ? locale : '';
}

/**
 * 当前用户状态或设置下的默认语言
 * TODO：可能是浏览器设置、IP等因素，暂时先就直接返回站点默认
 * @returns 默认语言
 */
export function getDefaultLocale(): string {
  return defaultLocale;
}

export function isSupportedLocale(locale = ''): boolean {
  return supportLocale.map((item) => item.value).includes(locale);
}
